import { Form, Modal } from "antd";
import { useState } from "react";
import { Constant } from "../../../constant";
import { NormalAlert } from "../../../export/AlertMessage";
import BaliseChamp from "../../../export/BaliseChamp";
import { Buttons, ButtonsItem, Inputs, InputsArea, PickerItem } from "../../../export/InputsChamp";
import Service from "../../../service";

export default function AjoutModal({ details, close, retourModal }) {
  
  const [form] = Form.useForm()
  const [spinner, setSpinner] = useState(false);
  const [formState, setFormState]= useState({
      champs: [
              Inputs({
                  label: Constant.fr.imei,
                  name: "imei",
                  rules: [
                    {required: true, message: Constant.fr.champsObligatoire},
                  ],
                  type: "text",
                  typeChamps: Constant.baliseData.typeChamp.Inputs,
                  styles: styles.input,
                  allowClear: true,
                  // helpMessage: <small style={{color: 'red', fontSize: 10}}>{Constant.fr.telephoneParDefaut}</small>,
                  xs: 24,
                  formItemStyles: styles.formItemStyles
                }),
              PickerItem({
                data: Constant.typeVehiculeGps,
                cols: 1,
                typeChamps: Constant.baliseData.typeChamp.Picker,
                label: Constant.fr.type,
                name: "type",
                styles: styles.input,
                rules: [{required: true, message: Constant.fr.champsObligatoire}],
                xs: 24,
                formItemStyles: styles.formItemStyles
              }),
              Inputs({
                  label: Constant.fr.nom,
                  name: "nom",
                  rules: [
                    {required: false, message: Constant.fr.champsObligatoire},
                  ],
                  type: "text",
                  typeChamps: Constant.baliseData.typeChamp.Inputs,
                  styles: styles.input,
                  allowClear: true,
                  // helpMessage: <small style={{color: 'red', fontSize: 10}}>{Constant.fr.telephoneParDefaut}</small>,
                  xs: 24,
                  formItemStyles: styles.formItemStyles
                }),
              Inputs({
                  label: Constant.fr.contact,
                  name: "contact",
                  rules: [
                    {required: false, message: Constant.fr.champsObligatoire},
                  ],
                  type: "text",
                  typeChamps: Constant.baliseData.typeChamp.Inputs,
                  styles: styles.input,
                  allowClear: true,
                  // helpMessage: <small style={{color: 'red', fontSize: 10}}>{Constant.fr.telephoneParDefaut}</small>,
                  xs: 24,
                  formItemStyles: styles.formItemStyles
                }),
                InputsArea({
                  label: Constant.fr.description,
                  name: "description",
                  rules: [
                    {required: false, message: Constant.fr.champsObligatoire},
                  ],
                  type: "text",
                  typeChamps: Constant.baliseData.typeChamp.InputsArea,
                  styles: styles.input,
                  allowClear: true,
                  rows: 2,
                  // helpMessage: <small style={{color: 'red', fontSize: 10}}>{Constant.fr.telephoneParDefaut}</small>,
                  xs: 24,
                  formItemStyles: styles.formItemStyles
                }),
            Buttons([
              ButtonsItem({
                text: details.data.gps === undefined ? Constant.fr.Ajouter : Constant.fr.Modifier,
                size: Constant.baliseData.size.large,
                typeChamps: Constant.baliseData.typeChamp.Buttons,
                onPress: Constant.baliseData.onPress.validate,
                colStyle: [{marginRight: 10}],
                styles: {color: Constant.couleur.secondary, borderColor: Constant.couleur.secondary},
                rowBalise: true,
                spinner: true,
                variant:"outlined",
                // textStyles: {color: "white", fontSize: 18},
                // activeStyle: [{backgroundColor: Constant.couleur.primary}],
              }),
            ],
            {
              rowBalise: true,
              spaceBetween: true,
              xs: 24
            }),
          ],
      layoutForm:Constant.baliseData.layoutForm.vertical,
      initialValues: details.data.gps !== undefined ? details.data.gps : {}
    })

    const onFinish = (values) => {
        setSpinner(true);
        if(details.data.gps === undefined) {
          Service.post(Constant.paths.addGps, "", values, true).then(
            async (response) => {
              setSpinner(false);
              NormalAlert("success", response.data.message);
              retourModal(response.data.data, 0)
              close()
            }, error => {
              setSpinner(false);
              if(error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
                  NormalAlert("error", error.response.data.message);
              } else {
                  NormalAlert("error", Constant.fr.accesRefuse);
              }
            }
          )
        } else {
          values.id = details.data.gps.id
          Service.putAll(Constant.paths.updateGps, "", values, true).then(
            async (response) => {
              setSpinner(false);
              NormalAlert("success", response.data.message);
              details.data.gps = response.data.data
              retourModal(details.data, 1)
              close()
            }, error => {
              setSpinner(false);
              if(error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) {
                  NormalAlert("error", error.response.data.message);
              } else {
                  NormalAlert("error", Constant.fr.accesRefuse);
              }
            }
          )
        }
    }

    const onFinishFailed = (errorInfo) => {
        setSpinner(false);
        NormalAlert("warning", 
          Constant.fr.renseignerChampsObligatoire
        )
      };

      const onSubmit = () => {
        form.submit()
      }

  return (
    <Modal
        title={details.data.gps === undefined ? Constant.fr.AjoutGps : Constant.fr.ModificationGps}
        // closable={{ 'aria-label': 'Custom Close Button' }}
        open={details.visibilite}
        style={{
          zIndex: 1500
        }}
        onCancel={(e) =>close()}
        footer={null}
      >
        <div style={{ paddingVertical: 10, backgroundColor: Constant.couleur.white, padding: 20, borderRadius: 10}}>
              <Form
                  name="AjoutModal"
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  layout={formState.layoutForm} 
                  initialValues={formState.initialValues}
                  >
                      <BaliseChamp spinnerBouton={spinner} form={form} formState={formState} onSubmit={onSubmit.bind()}/>
              </Form>
        </div>
      </Modal>
  );
}

const styles = {
  headerContainer: {
    height: 52,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingBottom: 0,
  },
  headerText: {
    flex: 1,
    fontSize: 22,
    fontFamily: 'WorkSans-Bold',
    textAlign: 'center',
    textAlignVertical: 'center',
  },
  input: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 5,
    width: "100%"
  },
  formItemStyles: {
    margin: 0,
    padding: 0
  },
};